<template lang="html">
<div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary" >
   <!-- CONTENT
    ================================================== -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-5 col-xl-4 my-5">

          <!-- Heading -->
          <h1 class="display-4 text-center mb-3">
            Crie uma nova senha
          </h1>

          <!-- Subheading -->
          <!-- <p class="text-muted text-center mb-5">
            Será enviado um e-mail com as instruções para você redefinir sua senha.
          </p> -->

          <!-- Form -->
          <form>

            <!-- Email address -->
            <div class="form-group">

              <!-- Label -->
              <label>Senha</label>

              <!-- Input -->
              <input type="password" class="form-control" placeholder="Digite" v-model="senha">

            </div>

            <!-- Submit -->
            <div v-if="isLoading" class="title-center" style="margin-top:30px;">
                  <atom-spinner 
                  :size="50"
                  :color="'#FFFFFF'"
                  />
            </div>
            <button v-else class="btn btn-lg btn-block btn-primary mb-3" style="margin-left: -3px;" @click.prevent="enviar">
              Entrar!
            </button>

          </form>
        </div>
      </div> <!-- / .row -->
    </div> <!-- / .container -->
    </div>
</template>

<script>
import axios from 'axios'
import {AtomSpinner} from 'epic-spinners'

export default {
  props:['token'], 
  components: {
    AtomSpinner
  },
  data (){
    return {
      senha: '',
      isLoading: false
    }
  },
  methods: {
    enviar (){      
      this.isLoading = true
      axios.post('account/password_reset/confirm/',{
        password: this.senha,
        token: this.token
      })
      .then(resp => {
        console.log(resp)
        this.isLoading = false
        this.$notify('Senha alterada com sucesso! Você seria redirecionado a pagina de login', 'success')
        setTimeout(() => {
            this.$router.push({name: 'Login'})
          }, 4000)   
      })
      .catch(err => {
        console.log(err)
        this.isLoading = false
        this.$notify('Erro!', 'error')
      })
    }
  }
}
</script>

<style>
</style>